import { render, staticRenderFns } from "./AvSkeletonBoard.vue?vue&type=template&id=2865710c&scoped=true"
import script from "./AvSkeletonBoard.vue?vue&type=script&lang=ts"
export * from "./AvSkeletonBoard.vue?vue&type=script&lang=ts"
import style0 from "./AvSkeletonBoard.vue?vue&type=style&index=0&id=2865710c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2865710c",
  null
  
)

export default component.exports